<template>
  <div>
    <tabs
      :links="contractsLinks"
      :mode="'emitter'"
      :current-tab="tab"
      @changeView="tab = $event"
      class="is-border-bottom">
    </tabs>
    <div>
      <div class="columns is-gapless is-vcentered is-border-bottom has-background-light is-minH50p is-marginless">
        <div class="column is-padding-left">
          <span class="is-size-6">Tous ({{ items.length }})</span>
        </div>
        <div class="column is-narrow is-border-left is-self-stretched">
          <router-link
            :to="{name: 'ContractCreate'}"
            class="button is-radiusless is-small is-primary is-minH100">
            <span class="has-text-weight-medium">Créer un nouveau contrat</span>
          </router-link>
        </div>
      </div>
      <spinner-round
        v-if="submitLoading"
        :is-loading="submitLoading" />
      <div
        v-else
        v-for="(contrat, i) in items"
        :key="i"
        class="is-flex is-margin is-border">
        <div class="is-border is-flex-center is-padding-top is-padding-bottom is-padding-left is-padding-right">
          <span class="icon is-small file-icon"><i class="fal fa-file-alt"></i></span>
        </div>
        <div class="column">
          <router-link
            :to="{ name: 'ContractEdit', params: { id: contrat.pk } }"
            class="columns is-multiline has-cursor-pointer">
            <div class="column is-9 is-border is-uppercase is-vcentered is-padding-top-small is-padding-bottom-small">
              {{ contrat.name }}
            </div>
            <div class="column is-3 is-paddingless">
              <div class="button is-uppercase is-fullwidth is-success is-radiusless fullheight">
                Modifier document
              </div>
            </div>
          </router-link>
          <div class="is-flex-between">
            <div class="">
              Date de création : le {{ contrat.created_on | prettyDate }}
            </div>
            <div class="columns">
              <div
                class="control">
                <span
                  class="button is-square has-text-grey is-action tooltip is-radiusless"
                  @click="openPreview(contrat)"
                  data-tooltip="Voir contrat">
                  <i class="far fa-eye"></i>
                </span>
              </div>
              <div
                class="control">
                <span
                  class="button is-square has-text-grey is-action tooltip is-radiusless"
                  @click="loadPdfLink(contrat)"
                  data-tooltip="Télécharger">
                  <i class="fal fa-download"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false">
      <template slot="breadcrumb">
        <h1 class="page-header-breadcrumb-item is-uppercase">
          <span>{{ total }} Contrat</span>
        </h1>
      </template>
      <template slot="before-actions">
        <router-link
          class="page-header-btn is-small is-secondary is-widthFixToHeaderAccount"
          :to="{name: 'ContractCreate'}">
          <span class="icon is-medium"><i class="fas fa-plus-circle"></i></span><span>Créer contrat</span>
        </router-link>
      </template>
    </page-nav-bar>
    <page-content
      :has-sticky-col-left="true"
      :has-left-col-collapse="false"
      :has-padd-right-normal="true">
      <div class="">
        <list-top-bar
          :count="count"
          label="contact(s)"
          :has-multiselection="false">
        </list-top-bar>
        <spinner-round
          :is-loading="loading"
          v-if="loading"></spinner-round>
        <table-controls-vue
          v-if="!loading && items.length"
          :has-sticky="true"
          :no-scroll-direction="true">
          <table class="table is-narrow is-fullwidth is-last-fixed-small has-actionsontd">
            <tbody class="has-cells-vcentered">
              <tr
                v-for="(contract) in items"
                :key="contract.pk"
                class="is-size-6"
                :id="'e' + contract.pk"
                :class="{'has-status-bar--left has-status-bar--draft': lastOpenedItemPk === contract.pk}">
                <td class="is-cell-hoverable">
                  <router-link
                    :to="{ name: 'ContractEdit', params: { id: contract.pk } }"
                    class="fullLink">
                    {{ contract.name }}
                  </router-link>
                </td>
                <td>
                  <display-button-list
                    :buttons="buttonList"
                    :data="contract">
                  </display-button-list>
                </td>
              </tr>
            </tbody>
          </table>
        </table-controls-vue>
        <div v-show="!loading && !items.length">
          <div class="is-padding">
            <h2 class="title is-3 has-text-weight-bold">
              Aucun contrat disponible
            </h2>
          </div>
        </div>
        <pagination
          :loading="loading"
          :current-page="currentPage"
          :total-page="totalPage"
          @changePage="loadItems($event)"></pagination>
      </div>
    </page-content>
  </div> -->
</template>

<script>
import { GenericList, Sort, DefaultValues, Filter } from '@/mixins'
import { mapState, mapGetters } from 'vuex'
import ContractMixin from './ContractMixin'

export default {
  name: 'ContractList',
  mixins: [GenericList, Sort, DefaultValues, Filter, ContractMixin],
  data () {
    return {
      tab: 'contract',
      items: [],
      submitLoading: false,
      contractsLinks: [
        // {
        //   label: 'Tous',
        //   link: 'all'
        // },
        {
          label: 'Contrat',
          link: 'contract'
        }
      ],
      buttonList: [
        {
          action: (id) => {
            this.$router.push({ name: 'ContractEdit', params: { id } })
          },
          text: 'Modifier',
          icon: 'fa-pencil'
        },
        {
          action: (id) => {
            this.deleteContract(id)
          },
          text: 'Supprimer',
          icon: 'fa-trash-alt'
        }
      ]
      // service: 'CONTRACT'
    }
  },
  computed: {
    ...mapState(['lastOpenedItemPk']),
    ...mapGetters(['canAddUsers'])
  },
  async created () {
  },
  methods: {
    async loadItems (page = null, perPage = null) {
      this.loading = true
      if (this.beforeGet) this.beforeGet()
      if (page) this.query.page = page
      if (perPage) this.query.per_page = perPage
      else this.query.per_page = this.perPage
      let { data } = await this.$api.axios.get('custom-contracts', this.query)
      data.items = data.items.filter(item => item.contract_type === 'promotion')
      this.successGet(data)
    },
    confirmDelete () {
      return this.$swal({
        title: 'Suppresion',
        text: 'Êtes vous sûr de vouloir supprimer ce modèle ?',
        focusConfirm: false,
        customClass: {
          confirmButton: 'is-danger'
        }
      })
    },
    async deleteContract (id) {
      let value = await this.confirmDelete()
      if (value.dismiss) return false // ON ne supprimme pas l'utilisateur
      if (value) {
        try {
          this.loading = true
          await this.$api.axios.delete(`custom-contracts/${id}`)
          this.loading = false
          this.loadItems()
        } catch (err) {
          console.log(err)
          this.$toasted.global.danger('Impossible de supprimer le modèle')
          this.loading = false
        }
      }
    }
  }
}
</script>

<style lang="sass">
.file-icon
  font-size: 52px
.fullheight
  height: 100%
</style>
